export { default } from './GridHotspot';
